export const themeDark = {
    axis: {
        fontSize: "14px",
        fontWeight: "bold",
        tickColor: "#EEE",
        ticks: {
            line: {
                stroke: "#EEE"
            },
            text: {
                fill: "#EEE",
                fontWeight: "bold",
            }
        },
        legend: {
            title: {
                text: {
                    fill: "#EEE",
                }
            },
            text: {
                fill: "#EEE",
            }
        }
    },
    grid: {
        line: {
            stroke: "#EEEA",
            strokeWidth: 0.25,
        }
    },
    labels: {
        text: {
            fontSize: 14,
            fill: "#FFF",
            weight: "bold"
        }
    },
    legends: {
        title: {
            text: {
                fill: "#EEE"
            }
        },
        text: {
            fill: "#EEE"
        }
    },
    tooltip: {
        container: {
            background: "#121121",
            color: "#fff"
        }
    }
};

export const themeLight = {
    axis: {
        fontSize: "14px",
        tickColor: "#000",
        fontWeight: "bold",
        ticks: {
            line: {
                stroke: "#000"
            },
            text: {
                fill: "#000",
                fontWeight: "bold",
            }
        },
        legend: {
            text: {
                fill: "#000"
            }
        }
    },
    grid: {
        line: {
            stroke: "#000",
            strokeWidth: 0.25,
        }
    },
    labels: {
        text: {
            fontSize: 14,
            fill: "#FFF",
            weight: "bold"
        }
    },
    legends: {
        title: {
            text: {
                fill: "#000"
            }
        },
        text: {
            fill: "#000"
        }
    }
};